import gql from 'graphql-tag';

const MEMBER_LICENSE_SEND_WALLET_PASS = gql`
mutation memberLicenseSendWalletPass($id: ID!) {
    memberLicenseSendWalletPass(id: $id)
}
`;

export default MEMBER_LICENSE_SEND_WALLET_PASS;